export const MAX_JOB_TITLE_ANSWERS = 6;
export const MIN_JOB_TITLE_ANSWERS = 1;

export const MAX_RELATED_JOB_TITLE_IDS = MAX_JOB_TITLE_ANSWERS * 2;
